import { render, staticRenderFns } from "./BankTransaction.vue?vue&type=template&id=778860e4&scoped=true&"
import script from "./BankTransaction.vue?vue&type=script&lang=js&"
export * from "./BankTransaction.vue?vue&type=script&lang=js&"
import style0 from "./BankTransaction.vue?vue&type=style&index=0&id=778860e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778860e4",
  null
  
)

export default component.exports